import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useFileUploadStore = defineStore('fileUpload', () => {
  
  const uploadSessions = ref({}) 

  
  const allFiles = computed(() => {
    const allFiles = []
    for (const session of Object.values(uploadSessions.value)) {
      allFiles.push(...session.files)
    }
    return allFiles
  })

  
  const addSession = (sessionId, initialFiles = []) => {
    if (!uploadSessions.value[sessionId]) {
      uploadSessions.value[sessionId] = {
        files: initialFiles,
        lastUpdate: new Date()
      }
    }
  }

  const removeSession = (sessionId) => {
    delete uploadSessions.value[sessionId]
  }

  const updateSessionFiles = (sessionId, files) => {
    const session = uploadSessions.value[sessionId]
    if (session) {
      session.files = files
      session.lastUpdate = new Date()
    }
  }

  const getSessionFiles = (sessionId) => {
    const session = uploadSessions.value[sessionId]
    return session ? session.files : []
  }

  const getFileStatus = (sessionId, fileId) => {
    const session = uploadSessions.value[sessionId]
    if (!session) return null
    
    return session.files.find(file => file.id === fileId)
  }

  const clearAllSessions = () => {
    uploadSessions.value = {}
  }

  return {
    
    uploadSessions,
    
    
    allFiles,
    
    
    addSession,
    removeSession,
    updateSessionFiles,
    getSessionFiles,
    getFileStatus,
    clearAllSessions
  }
}) 